import { createContext, useContext, useState, useEffect } from "react";

const ThemeContext = createContext();

// Las paletas viven en src/styles/tokens.css, colgadas de data-bs-theme.
// Acá solo se elige el tema: un único atributo mueve a la vez nuestras
// variables --c-* y las de Bootstrap.

export function ThemeProvider({ children }) {
  const [isDark, setIsDark] = useState(() => {
    try { return localStorage.getItem('theme') !== 'light'; }
    catch { return true; }
  });

  useEffect(() => {
    document.body.classList.toggle('theme-dark',  isDark);
    document.body.classList.toggle('theme-light', !isDark);
    document.documentElement.setAttribute('data-bs-theme', isDark ? 'dark' : 'light');
    try { localStorage.setItem('theme', isDark ? 'dark' : 'light'); } catch {}
  }, [isDark]);

  const toggleTheme = () => setIsDark(d => !d);

  return (
    <ThemeContext.Provider value={{ isDark, toggleTheme }}>
      {children}
    </ThemeContext.Provider>
  );
}

export function useTheme() {
  const ctx = useContext(ThemeContext);
  if (!ctx) throw new Error('useTheme debe usarse dentro de ThemeProvider');
  return ctx;
}

export default ThemeContext;
